import React from 'react';
import { useJarvisState } from '../hooks/useJarvisState';

const StatusIndicator: React.FC = () => {
  const { state } = useJarvisState();

  const getStatusColor = () => {
    switch (state) {
      case 'listening':
        return 'bg-green-500';
      case 'thinking':
        return 'bg-yellow-500';
      case 'speaking':
        return 'bg-blue-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusText = () => {
    switch (state) {
      case 'listening':
        return 'Ouvindo...';
      case 'thinking':
        return 'Pensando...';
      case 'speaking':
        return 'Falando...';
      default:
        return 'Pronto';
    }
  };

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-surface-light/50 backdrop-blur-sm">
      <div className={`w-2 h-2 rounded-full ${getStatusColor()} ${
        state !== 'idle' ? 'animate-pulse' : ''
      }`} />
      <span className="text-sm text-text-secondary">{getStatusText()}</span>
    </div>
  );
};

export default StatusIndicator;
